export default __webpack_public_path__ + "90ba4d3381b33da366b7b7d021cbd4e4.png";